import { render, staticRenderFns } from "./SpecialReview.vue?vue&type=template&id=3b7cec66"
import script from "./SpecialReview.vue?vue&type=script&lang=js"
export * from "./SpecialReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports